const CustomerChangeLoading = () => {
  return (
    <div className="w-full h-8 flex items-center border-b-2 border-gray-300 p-2">
      <div className="w-1/12">
        <div className="h-3 bg-gray-300 animate-pulse rounded" />
      </div>
      <div className="w-3/12">
        <div className="h-3 bg-gray-300 animate-pulse rounded" />
      </div>
      <div className="w-2/12">
        <div className="h-3 bg-gray-300 animate-pulse rounded" />
      </div>
      <div className="w-2/12">
        <div className="h-3 bg-gray-300 animate-pulse rounded" />
      </div>
      <div className="w-2/12">
        <div className="h-3 bg-gray-300 animate-pulse rounded" />
      </div>
      <div className="w-2/12">
        <div className="h-3 bg-gray-300 animate-pulse rounded" />
      </div>
    </div>
  );
};

export default CustomerChangeLoading;
